export default __webpack_public_path__ + "static/media/logo-us-lulu-lemon.532a3d10.svg";